
// obj.toString() => eventName => eventListenerId

let lastHandelEventsFuncs = {}

// eventListener_addEventListenerToObj
export const eventListener_addEventListenerToObj = (obj, eventName, immediateRun_b, eventListenerId, handleEvent_cb) => {

    // set obj dictionary
    if (lastHandelEventsFuncs[getUniqueId_f(obj)] == null){
        lastHandelEventsFuncs[getUniqueId_f(obj)] = {}
    }

    // set obj dictionary
    if (lastHandelEventsFuncs[getUniqueId_f(obj)][eventName] == null){
        lastHandelEventsFuncs[getUniqueId_f(obj)][eventName] = {}
    }


    // remove event listener if exist
    if (lastHandelEventsFuncs[getUniqueId_f(obj)][eventName][eventListenerId] != null) {
        console.log('add existing', eventName, lastHandelEventsFuncs)
        eventListener_removeEventListenerToObj(obj, eventName, eventListenerId)
    }

    // add event listener
    lastHandelEventsFuncs[getUniqueId_f(obj)][eventName][eventListenerId] = handleEvent_cb
    obj.addEventListener(eventName, handleEvent_cb)

    if (immediateRun_b) {
        handleEvent_cb()
    }
}

// eventListener_removeEventListenerToObj
export const eventListener_removeEventListenerToObj = (obj, eventName, eventListenerId) => {

    if(!lastHandelEventsFuncs[getUniqueId_f(obj)] || !lastHandelEventsFuncs[getUniqueId_f(obj)][eventName] || !lastHandelEventsFuncs[getUniqueId_f(obj)][eventName][eventListenerId]){
        console.log('remove not existing ', eventName, eventListenerId)
        return
    }

    obj.removeEventListener(eventName, lastHandelEventsFuncs[getUniqueId_f(obj)][eventName][eventListenerId])
    delete lastHandelEventsFuncs[getUniqueId_f(obj)][eventName][eventListenerId]
}

let idCounter = new Date().getTime();
const getUniqueId_f = ( node ) => {
    return node.objId ? node.objId : (node.objId = 'tempIdPrefix_' + idCounter++)
}
